export default [
    {
        path: 'publish-manage',
        name: '内容发布',
        component: () => import(/* webpackChunkName: "share-output" */ './ouput-publish-manage/index.vue'),
        children: [
            {
                path: '/',
                redirect: 'publish-create',
            },
            {
                path: 'publish-create',
                name: '内容创作',
                component: () =>
                    import(/* webpackChunkName: "share-output" */ './ouput-publish-manage/publish-manage-create.vue'),
            },
            {
                path: 'publish-video',
                name: '新增视频',
                component: () =>
                    import(/* webpackChunkName: "share-output" */ './ouput-publish-manage/publish-manage-video.vue'),
            },
            {
                path: 'publish-file',
                name: '新增文件',
                component: () =>
                    import(/* webpackChunkName: "share-output" */ './ouput-publish-manage/publish-manage-file.vue'),
            },
        ],
    },
    {
        path: 'column-manage',
        name: '专栏管理',
        component: () => import(/* webpackChunkName: "share-output" */ './output-column-manage/index.vue'),
        children: [
            {
                path: '/',
                redirect: 'column-card',
            },
            {
                path: 'column-card',
                name: '所有专栏',
                component: () =>
                    import(/* webpackChunkName: "share-output" */ './output-column-manage/column-card.vue'),
            },
            {
                path: 'column-add',
                name: '新增专栏',
                component: () => import(/* webpackChunkName: "share-output" */ './output-column-manage/column-add.vue'),
            },
            {
                path: 'column-detail',
                name: '专栏详情',
                component: () =>
                    import(/* webpackChunkName: "share-output" */ './output-column-manage/column-detail.vue'),
            },
        ],
        // import(/* webpackChunkName: "share-output" */ './output-column-manage/index.vue'),
    },
    {
        path: 'learncoin-manage',
        name: '收益管理',
        component: () => import(/* webpackChunkName: "share-output" */ './output-learncoin-manage/index.vue'),
    },
    {
        path: 'member-manage',
        name: '成员管理',
        component: () => import(/* webpackChunkName: "share-output" */ './output-member-manage/index.vue'),
    },
    {
        path: 'output-detail',
        name: '内容管理详情',
        component: () => import(/* webpackChunkName: "share-output" */ './share-output-content-detail.vue'),
    },
];
